document.addEventListener("DOMContentLoaded", function(event) {

	let swiperIndex = document.querySelector(".JS-swiper-partners");
	const swiper = new Swiper(swiperIndex, {
		autoplay: true,
		speed: 2000,
		loop: true,
		spaceBetween: 10,

		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 0
			},
			650: {
				slidesPerView: 2,
				spaceBetween: 20
			},
			767: {
				slidesPerView: 3,
				spaceBetween: 10
			},
			980: {
				slidesPerView: 4,
				spaceBetween: 10
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 10
			}
		}

	});
});